import { render, staticRenderFns } from "./List-9.vue?vue&type=template&id=96c4b3d6&scoped=true"
import script from "./List-9.vue?vue&type=script&lang=js"
export * from "./List-9.vue?vue&type=script&lang=js"
import style0 from "./List-9.vue?vue&type=style&index=0&id=96c4b3d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c4b3d6",
  null
  
)

export default component.exports